import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  template: `
     <div class="modal-body">
      <div class="form-row">
        <div class="form-group col-12">
          <div
            class="text-danger"
            *ngIf="errorMessages"
          >
            <p  *ngFor="let error of errorMessages | keyvalue">{{error.value}}</p>
          </div>
        </div>
      </div>
  </div>

  <div class="modal-footer">
    <div class="form-group">
      <div class="col-12 d-flex justify-content-between">
        <button (click)="bsModalRef.hide()" class="btn btn-sm btn-light mr-2">
          <i class="la la-ban"></i>
          {{ "navigations.close" | translate }}
        </button>
      </div>
    </div>
  </div>

  `,
})
export class ErrorMessagesModalComponent {
  constructor(public bsModalRef: BsModalRef) { }
  @Input() errorMessages: string[] = [];
}
